import React from 'react';

class PrivacyPolicy extends React.Component {
  handleBack = () => {
    if (this.props.history) {
      this.props.history.goBack();
    } else {
      window.history.back();
    }
  };

  render() {
    return (
      <div style={containerStyle}>
        {/* --- FIXED APP TOOLBAR --- */}
        <div style={toolbarStyle}>
          <button onClick={this.handleBack} style={iconButtonStyle}>
            ←
          </button>
          <div style={toolbarTitleStyle}>Privacy Policy</div>
          <div style={{ width: '40px' }}></div>{' '}
          {/* Spacer to center the title */}
        </div>

        <div style={cardStyle}>
          {/* Header Section */}
          <header style={headerStyle}>
            <h1 style={titleStyle}>Privacy Policy</h1>
            <p style={{ ...dateStyle, fontStyle: 'italic' }}>
              Last Updated: June 12, 2026
            </p>
          </header>

          {/* Content Section */}
          <div style={contentStyle}>
            <section style={sectionStyle}>
              <h2 style={headingStyle}>1. Introduction</h2>
              <p>
                DevyX ("we," "our," or "us") operates the NuVe System mobile
                application (the "App"). This Privacy Policy explains how we
                collect, use, disclose, and safeguard your information when you
                use our App.
              </p>
              <p>
                Please read this Privacy Policy carefully. By using the App, you
                agree to the collection and use of information in accordance
                with this policy.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>2. Information We Collect</h2>
              <p>
                NuVe System is a customer management application designed for
                business operators to manage their client base. When you visit a
                location using our system, we collect the following personal
                information:
              </p>
              <ul style={listStyle}>
                <li>
                  <strong>Full Legal Name:</strong> To identify and maintain
                  your customer profile
                </li>
                <li>
                  <strong>Phone Number:</strong> Used as your membership
                  identifier for check-in purposes, verified via a one-time SMS
                  code
                </li>
                <li>
                  <strong>Date of Birth:</strong> For age verification and
                  record-keeping
                </li>
                <li>
                  <strong>Address:</strong> For contact and location purposes
                </li>
                <li>
                  <strong>Driver's License Number:</strong> For identification
                  verification
                </li>
                <li>
                  <strong>Points Information:</strong> To track your loyalty or
                  membership status
                </li>
                <li>
                  <strong>Registration Details:</strong> Information about who
                  registered your profile
                </li>
                <li>
                  <strong>Comments:</strong> Any additional notes or information
                  relevant to your customer profile
                </li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>3. How We Use Your Information</h2>
              <p>
                We use the collected information for the following purposes:
              </p>
              <ul style={listStyle}>
                <li>
                  To maintain and manage customer profiles within the business
                  system
                </li>
                <li>
                  To verify customer identity when checking in at locations
                </li>
                <li>To track membership and loyalty points</li>
                <li>
                  To maintain organized business records and workflow management
                </li>
                <li>
                  To improve our internal business operations and customer
                  service
                </li>
                <li>To comply with legal and regulatory requirements</li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>3A. SMS / Text Messaging Program</h2>
              <p>
                NuVe System uses SMS text messaging for two distinct purposes,
                each with its own consent:
              </p>
              <ul style={listStyle}>
                <li>
                  <strong>
                    Account &amp; Verification Messages (required):
                  </strong>{' '}
                  When you check in or activate a membership, we send a one-time
                  verification code (OTP) to confirm that the phone number
                  belongs to you. These messages are limited to identity
                  verification, account access, and membership management. You
                  consent to these messages by accepting the Phone Verification
                  notice presented during check-in or membership activation.
                </li>
                <li>
                  <strong>
                    Member Benefits &amp; Promotional Messages (optional):
                  </strong>{' '}
                  Only if you separately and expressly opt in by checking the
                  Member Benefits &amp; Promotions consent box, you may receive
                  recurring promotional offers, special event announcements,
                  loyalty program updates, membership rewards, and business
                  updates by SMS from the participating business location,
                  delivered through NuVe System.
                </li>
              </ul>
              <p>
                <strong>
                  Message frequency varies. Message and data rates may apply.
                </strong>{' '}
                Consent to receive promotional messages is <strong>not</strong>{' '}
                a condition of membership or of using NuVe System.
              </p>
              <p>
                <strong>Opt out:</strong> You may opt out of promotional
                messages at any time by replying <strong>STOP</strong> to any
                promotional message, or by updating your communication
                preferences with the business location. <strong>Help:</strong>{' '}
                Reply <strong>HELP</strong> to any message or contact us at
                info@nuvesystem.com for assistance.
              </p>
              <div style={importantNoticeStyle}>
                <strong>No Sharing of Mobile Information:</strong> Mobile phone
                numbers, SMS consent, and text messaging originator opt-in data
                will <strong>not</strong> be shared with, sold to, or rented to
                any third parties or affiliates for their own marketing or
                promotional purposes, under any circumstances.
              </div>
              <p>
                We record the date, time, and location of each consent you
                provide, and these records are retained as proof of your opt-in.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>
                4. Software Provider Role and Business Independence
              </h2>
              <p>
                <strong>Platform Provider Only:</strong> NuVe System is a
                software platform provided by DevyX to independently owned and
                operated businesses. We do not own, operate, manage, or control
                any physical business locations that use our App.
              </p>

              <p>
                <strong>Phone Number Technical Requirement:</strong> Our system
                requires a valid phone number for technical and security
                purposes. Phone numbers serve as the primary authentication
                method, enabling secure login through SMS-based verification
                codes. This is a core technical requirement of our platform's
                security architecture.
              </p>

              <p>
                <strong>Business Operator Independence:</strong> Each business
                operator independently determines their own customer
                registration practices, membership policies, and access
                requirements. We do not control, dictate, or participate in
                these business decisions.
              </p>

              <p>
                <strong>Data Processor Role:</strong> In providing our software
                platform, DevyX acts as a data processor on behalf of business
                operators who are the data controllers. Business operators
                determine what personal information to collect and how to use it
                within their operations.
              </p>

              <div style={importantNoticeStyle}>
                <strong>No Liability for Business Practices:</strong> We are not
                responsible for and do not control how business operators use
                our software, apply their policies, or manage their customer
                relationships. Any disputes or concerns about business practices
                should be directed to the specific business operator.
              </div>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>
                5. No User Accounts or Login Credentials
              </h2>
              <p>
                NuVe System does not create traditional user accounts with
                passwords. Customers use their phone number to check in at
                participating locations. All data is managed internally by
                business operators and is not accessible to customers through
                the app.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>6. Data Storage and Security</h2>
              <p>
                We implement appropriate technical and organizational security
                measures to protect your personal information against
                unauthorized access, alteration, disclosure, or destruction.
                However, no method of transmission over the internet or
                electronic storage is 100% secure, and we cannot guarantee
                absolute security.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>7. Data Sharing and Disclosure</h2>
              <p>
                We do not sell, trade, or rent your personal information to
                third parties. We may share your information only in the
                following circumstances:
              </p>
              <ul style={listStyle}>
                <li>
                  With business operators using our system to manage their
                  customer base
                </li>
                <li>When required by law or to respond to legal process</li>
                <li>
                  To protect our rights, property, or safety, or that of our
                  users or the public
                </li>
                <li>
                  With service providers who assist us in operating the App
                  (under strict confidentiality agreements)
                </li>
              </ul>
              <p>
                <strong>
                  All of the above categories exclude text messaging originator
                  opt-in data and consent; this information will not be shared
                  with, sold to, or rented to any third party or affiliate for
                  marketing or promotional purposes.
                </strong>
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>8. Third-Party Services</h2>
              <p>
                NuVe System does not use third-party analytics, advertising
                networks, or behavioral tracking technologies.
              </p>
              <p>
                We use a third-party SMS delivery provider solely to transmit
                verification codes and, where you have expressly opted in,
                promotional messages on our behalf. This provider is bound by
                confidentiality obligations and may not use your phone number or
                message data for any other purpose.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>9. Age Requirement</h2>
              <p>
                Our App is intended for use only by individuals who are 18 years
                of age or older. We do not knowingly collect personal
                information from anyone under the age of 18. If you are a parent
                or guardian and believe someone under 18 has provided us with
                personal information, please contact us immediately so we can
                remove that information.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>10. Data Retention</h2>
              <p>
                We retain your personal information for as long as necessary to
                fulfill the purposes outlined in this Privacy Policy, unless a
                longer retention period is required or permitted by law.
                Business operators may retain customer data as needed for their
                business operations. Records of SMS consent (including the date,
                time, and location of opt-in) are retained as required to
                demonstrate compliance with applicable messaging regulations.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>11. Your Rights</h2>
              <p>
                Depending on your location, you may have certain rights
                regarding your personal information, including:
              </p>
              <ul style={listStyle}>
                <li>The right to access your personal information</li>
                <li>
                  The right to request correction of inaccurate information
                </li>
                <li>The right to request deletion of your information</li>
                <li>The right to object to processing of your information</li>
                <li>
                  The right to withdraw consent to promotional text messages at
                  any time by replying STOP
                </li>
              </ul>
              <p>
                To exercise these rights, please contact the business location
                where your information was collected, or contact us directly
                using the information below.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>12. Changes to This Privacy Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. We will
                notify you of any changes by posting the new Privacy Policy on
                this page and updating the "Last Updated" date. You are advised
                to review this Privacy Policy periodically for any changes.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>13. California Privacy Rights</h2>
              <p>
                If you are a California resident, you have specific rights under
                the California Consumer Privacy Act (CCPA) regarding your
                personal information. For more information about your California
                privacy rights, please contact us.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>14. International Users</h2>
              <p>
                If you are accessing the App from outside the United States,
                please be aware that your information may be transferred to,
                stored, and processed in the United States where our servers are
                located and our central database is operated.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={headingStyle}>15. Contact Us</h2>
              <p>
                If you have any questions about this Privacy Policy or our data
                practices, please contact us at:
              </p>
              <div style={contactBoxStyle}>
                NuVe System
                <br />
                info@nuvesystem.com
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

// Styles (Identical to TermsAndConditions for consistency)

const dateStyle = {
  color: '#777',
  fontSize: '0.95rem',
  fontWeight: '400',
};

const contentStyle = {
  textAlign: 'left',
};

const sectionStyle = {
  marginBottom: '35px',
};

const headingStyle = {
  color: '#001665',
  fontSize: '1.3rem',
  marginBottom: '15px',
  fontWeight: '700',
};

const listStyle = {
  paddingLeft: '25px',
  marginBottom: '15px',
};

const importantNoticeStyle = {
  backgroundColor: '#f8f9ff',
  borderLeft: '4px solid #001665',
  padding: '15px 20px',
  marginTop: '15px',
  fontSize: '0.95rem',
  fontStyle: 'italic',
};

const contactBoxStyle = {
  backgroundColor: '#f4f4f4',
  padding: '20px',
  borderRadius: '8px',
  marginTop: '10px',
  display: 'inline-block',
  minWidth: '250px',
};

const toolbarStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  height: '60px',
  backgroundColor: '#001665',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 15px',
  zIndex: 1000,
  boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
};

const iconButtonStyle = {
  backgroundColor: 'transparent',
  color: 'white',
  border: 'none',
  fontSize: '24px',
  cursor: 'pointer',
  padding: '10px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const toolbarTitleStyle = {
  color: 'white',
  fontSize: '18px',
  fontWeight: '600',
};

const containerStyle = {
  backgroundColor: '#ffffff', // Match your dark blue background
  minHeight: '100vh',
  paddingTop: '80px', // Space for the fixed toolbar
  paddingBottom: '40px',
  paddingLeft: '15px',
  paddingRight: '15px',
  display: 'flex',
  justifyContent: 'center',
  fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif',
};

const cardStyle = {
  backgroundColor: '#ffffff',
  maxWidth: '900px',
  width: '100%',
  padding: '30px 20px', // Tighter padding for mobile responsiveness
  borderRadius: '12px',
  color: '#333',
  lineHeight: '1.7',
};

const headerStyle = {
  borderBottom: '3px solid #001665',
  marginBottom: '30px',
  paddingBottom: '15px',
};

const titleStyle = {
  color: '#001665',
  fontSize: '1.8rem', // Slightly smaller for mobile compatibility
  margin: '0 0 10px 0',
};

export default PrivacyPolicy;
